<h2 mat-dialog-title>Artikel - KV {{ stop.kaufvertragsnummer || '-' }}</h2>

<mat-dialog-content class="articles-dialog-content">
  <p class="articles-customer" *ngIf="stop.customerName">{{ stop.customerName }}</p>
  <p class="articles-address text-muted">{{ stop.address }}</p>

  <div class="articles-kosten-summary" *ngIf="data.kostenGesamt != null || stop.kostenGesamt != null">
    <div class="kosten-row">
      <span>Lieferung (EK)</span>
      <strong>{{ formatCurrency(stop.lieferkostenEK) }}</strong>
    </div>
    <div class="kosten-row">
      <span>Montage (EK)</span>
      <strong>{{ formatCurrency(stop.montagekostenEK) }}</strong>
    </div>
    <div class="kosten-row" *ngIf="(data.distanceSurcharge ?? 0) > 0">
      <span>Fernzuschlag (&gt; 40 km)</span>
      <strong>{{ formatCurrency(data.distanceSurcharge) }}</strong>
    </div>
    <div class="kosten-row kosten-row-total">
      <span>Gesamt Lieferung + Montage</span>
      <strong>{{ formatCurrency(data.kostenGesamt ?? stop.kostenGesamt) }}</strong>
    </div>
    <div class="kosten-row kosten-row-meta text-muted" *ngIf="stop.liefermenge || stop.montagemenge">
      <span>Mengen</span>
      <span>Lieferung {{ formatMenge(stop.liefermenge) }} - Montage {{ formatMenge(stop.montagemenge) }}</span>
    </div>
  </div>

  <p class="hint" *ngIf="!articles.length">Keine Artikelzeilen aus dem CSV-Import vorhanden.</p>

  <div class="articles-table-wrap" *ngIf="articles.length">
    <table class="articles-table">
      <thead>
        <tr>
          <th>Pos.</th>
          <th>Art.-Nr.</th>
          <th>Bezeichnung</th>
          <th class="num">Lief.</th>
          <th class="num">Lief. EK</th>
          <th class="num">Mont.</th>
          <th class="num">Mont. EK</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of articles">
          <td>{{ row.position || '-' }}</td>
          <td>{{ row.artikelnummer || '-' }}</td>
          <td>{{ row.bezeichnung || '-' }}</td>
          <td class="num">{{ formatMenge(row.liefermenge) }}</td>
          <td class="num">{{ formatCurrency(row.lieferkostenEK) }}</td>
          <td class="num">{{ formatMenge(row.montagemenge) }}</td>
          <td class="num">{{ formatCurrency(row.montagekostenEK) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button type="button" class="btn btn-primary" (click)="close()">Schliessen</button>
</mat-dialog-actions>
